import React, { memo } from 'react';

import { Card, CardBody, CardHeader, Modal } from 'reactstrap';

import Form from './Form';

import util from '~/assets/util';

interface EditProductPriceModalProps {
  isOpen: boolean;
  productId: any;
  toggle: any;
  onClose: any;
  onSave: any;
}

function EditProductPriceModal({
  isOpen,
  productId,
  onClose,
  onSave,
  toggle,
}: EditProductPriceModalProps) {
  return (
    <Modal autoFocus={false} isOpen={isOpen} toggle={toggle} size="xl">
      <Card>
        <CardHeader>{util.t('PRODUCT')}</CardHeader>
        <CardBody>
          <Form id={productId} onClose={onClose} onSave={onSave} />
        </CardBody>
      </Card>
    </Modal>
  );
}

export default memo(EditProductPriceModal);
